"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SearchFilters = require("../../../types/SearchFilters");

var facilitiesBuilder = function facilitiesBuilder(_a) {
  var facilities = _a.facilities;

  if (!facilities || facilities && facilities.length === 0) {
    return '';
  }

  var query = [];

  if (facilities.includes(_SearchFilters.FacilitiesValue.PRIVATE_BATHROOM)) {
    query.push("facility_bathroom:" + _SearchFilters.Options.PRIVATE);
  }

  if (facilities.includes(_SearchFilters.FacilitiesValue.BALCONY_TERRACE)) {
    query.push("(" + [_SearchFilters.Options.PRIVATE, _SearchFilters.Options.SHARED].map(function (i) {
      return "facility_balcony_terrace:" + i;
    }).join(' OR ') + ")");
  }

  if (facilities.includes(_SearchFilters.FacilitiesValue.GARDEN)) {
    query.push("(" + [_SearchFilters.Options.PRIVATE, _SearchFilters.Options.SHARED].map(function (i) {
      return "facility_garden:" + i;
    }).join(' OR ') + ")");
  }

  if (facilities.includes(_SearchFilters.FacilitiesValue.KITCHEN)) {
    query.push("(" + [_SearchFilters.Options.PRIVATE, _SearchFilters.Options.SHARED].map(function (i) {
      return "facility_kitchen:" + i;
    }).join(' OR ') + ")");
  }

  if (facilities.includes(_SearchFilters.FacilitiesValue.PET_FRIENDLY)) {
    query.push('facility_animal_allowed:yes');
  }

  if (facilities.includes(_SearchFilters.FacilitiesValue.PARKING)) {
    query.push("(" + [_SearchFilters.Options.PRIVATE, _SearchFilters.Options.SHARED].map(function (i) {
      return "facility_parking:" + i;
    }).join(' OR ') + ")");
  }

  if (facilities.includes(_SearchFilters.FacilitiesValue.WHEELCHAIR_ACCESSIBLE)) {
    query.push('facility_wheelchair_accessible:yes');
  }

  if (facilities.includes(_SearchFilters.FacilitiesValue.BASEMENT)) {
    query.push("(" + [_SearchFilters.Options.PRIVATE, _SearchFilters.Options.SHARED].map(function (i) {
      return "facility_basement:" + i;
    }).join(' OR ') + ")");
  }

  return query.join(' AND ');
};

var _default = facilitiesBuilder;
exports["default"] = _default;